module.exports = __webpack_public_path__ + "img/Avatar-5.eca0612e.svg";